import { render, staticRenderFns } from "./RuleActionsSelector.vue?vue&type=template&id=ca94c74e&"
import script from "./RuleActionsSelector.vue?vue&type=script&lang=js&"
export * from "./RuleActionsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports